import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Lock it up';
  subTitle = 'An interface for input confirmation'
}



// WEBPACK FOOTER //
// /Users/Dan/Documents/PoC/angular-giaa/src/app/app.component.ts